import React, { useCallback, useContext } from "react";
import { SubmissionCompetitionConfigData } from "../Shared/Party/PartyConfigData";
import { LandingPage } from "./LandingPage";
import { DynamicForm, DynamicFormProps } from "./DynamicForm";
import { StateManagerContext } from "./StateManagerContext";
import { DynamicFormElement } from "../Shared/DynamicFormElement";
import { PurchaseBoosts } from "./PurchaseBoosts";
import { UIConfigContext } from "./UIConfigContext";
import { ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";

export type SubmissionCompetitionDisplayProps = {
    height: number;
}

export type SubmissionCompetitionProps = {
    config: SubmissionCompetitionConfigData,
    display: SubmissionCompetitionDisplayProps
}

type SubmissionCompetitionState = 'landing' | 'entry' | 'thankyou';

export const SubmissionCompetition = ({ config, display }: SubmissionCompetitionProps): JSX.Element => {
    const [submissionState, setSubmissionState] = React.useState<SubmissionCompetitionState>('landing');
    const uiConfig = React.useContext(UIConfigContext)
    const stateManager = useContext(StateManagerContext);
    //const authContext = React.useContext(AuthenticationContext);
    const dataRef = React.useRef<{ [key: string]: string }>({});


    const landingEntryHandler: ActionHandler = (_action) => {

        //if (stateManager.user().cognito === undefined)
        //  uiConfig.showEventOverlay('signIn',{})
        setSubmissionState('entry');
        return true;
    }

    const landingAction = CreateAction('onLandingClick', [
        {
            permission: 'signedIn'
        }, 
        {
            permission: 'boosts',
            threshold: 1000
        }
    ], landingEntryHandler);



    const doSubmission = async () => {
        const dataPackage = {
            userId: stateManager.user().fanbox.id,
            accessToken: stateManager.user().fanbox.accessToken ?? '',
            itemId: config.itemId,
            dynamicForm: config.submission,
            submission: dataRef.current
        }

        const worker = async () => {
            const uri = '/api/submissioncompetition';
            const response = await fetch(uri, {
                method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify(dataPackage)
            });
        }

        worker();
        setSubmissionState('thankyou');

    }

    const submissionSubmit = async (data: { [key: string]: string }) => {
        if (stateManager.user().cognito !== undefined) {
            dataRef.current = data;
            if (stateManager.user().accountInformation.boostBalance < 1000)
                setSubmissionState('entry');
            else
                doSubmission();

        }
        else {
            setSubmissionState('thankyou');
        }


    };

    const submissionCancel = () => {
        setSubmissionState('landing');
    };

    const purchaseCallback = (purchase: boolean) => {
        if (purchase)
            doSubmission();
        else
            setSubmissionState('entry');

    }

    const thankyouHandler: ActionHandler = (_action) => { return true; };
    const thankyouAction = CreateAction('onThankyouClick', [], thankyouHandler);

    const noEntryText = 'You need 1000 boosts to enter this competition.';




    if (submissionState === 'landing') {
        return <LandingPage showEnterButton={true} height={display.height} image={config.image} heading={config.title}
            subHeading={config.subtitle} description={config.description} buttonText={config.buttonText} action={landingAction} actionData={EmptyActionData} noEntryText={noEntryText} absolute={false} />
    }
    else if (submissionState === 'entry') {

        var submission = config.submission;
        if (stateManager.user().cognito === undefined)
            uiConfig.showEventOverlay('signIn', {});
        else if (stateManager.user().accountInformation.boostBalance < 1000) {
            submission = Array<DynamicFormElement>();
            submission.push({
                elementType: 'text',
                name: 'boostWarning',
                label: 'You do not have the 1000 boosts you need to enter competition, when you click to enter you will be able to buy the boosts you need.',
                defaultValue: '',
                options: []
            });
            submission.push(...config.submission);
        }



        const props: DynamicFormProps = {
            elements: submission,
            submissionButtonText: 'Submit',
            submissionColor: 'darkYellow',
            submissionTextColor: 'black',
            cancelButtonText: 'cancel',
            cancelColor: 'midGray',
            cancelTextColor: 'black',
            submit: submissionSubmit,
            cancel: submissionCancel,
            height: display.height,
            width: uiConfig.width,
            background: uiConfig.contolBackground,
            fontSize: uiConfig.fontBase,
            textColor: 'white',
            controlColor: '#303030',
            controlTextColor: 'black',
            submissionDisableColor: 'midGray',
            linkColor: 'white'

        }
        return <DynamicForm {...props} />
    }
    /*else if (submissionState === 'payment') {
        return <PurchaseBoosts  height={display.height} boostNeed={1000} callback={purchaseCallback} />
    }*/
    else {
        return <LandingPage showEnterButton={false} height={display.height} image={config.image} heading='Thank You'
            subHeading='For Your Entry' description={config.thankYouMessage} buttonText='Thank You' action={thankyouAction} actionData={EmptyActionData} absolute={false} noEntryText=""
        />
    }

}
